import type { GranularityUnit } from '~/state/useGranularityState'
import type { GranularityGovernance } from './granularityGovernance'
import { GRANULARITY } from '~/components/Charts/chrome/chartChrome'

export const UNIT_LABEL: Record<GranularityUnit, string> = GRANULARITY.unitAdverb

/** e.g. "Weekly — timeframe too large for daily values". */
export function coarseningSummary(g: GranularityGovernance): string {
  return `${GRANULARITY.unitAdverb[g.effectiveUnit]} — timeframe too large for ${GRANULARITY.unitNoun[g.requestedUnit]}`
}

/** e.g. "⚠ Monthly" — the compact per-tile marker label. */
export function coarseningMarkerLabel(g: GranularityGovernance): string {
  return `⚠ ${GRANULARITY.unitAdverb[g.effectiveUnit]}`
}
